import React, { useState } from "react";
import Tilt from "react-parallax-tilt";
import { QRCodeSVG } from "qrcode.react";
import logo from './logo.png'
const DigitalPlatinumCard = () => {
  const [flipped, setFlipped] = useState(false);

  return (
    <div className="card-container pt-5">
      <Tilt glareEnable={true} glareMaxOpacity={0.25} scale={1.05} tiltMaxAngleX={10} tiltMaxAngleY={10}>
        <div className={`platinum-card ${flipped ? "flipped" : ""}`}>
          {/* Front Side */}
          <div className="card-face card-front p-4">
            <h5 className="brand-title text-center mb-4 d-flex align-items-center">
       <div className="logo-circle d-flex align-items-center justify-content-center me-3 "><img src={logo} width='70' height='auto' alt="" />  </div>      Perfect Tools
            </h5>

            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
               
                  
                
                <div>
                  <h5 className="card-name mb-1">Satish Singh</h5>
                  <p className="card-role mb-1">Director</p>
                  <p className="card-phone mb-0">+91 9310414808</p>
                  <p className="card-phone mb-0">+91 9873241808</p>

                </div>
              </div>
              <div className="qr-code-front">
                <QRCodeSVG
                  value={`BEGIN:VCARD
VERSION:3.0
N:Satish Singh
TEL:+919310414808
EMAIL:satish.perfect@yahoo.com
END:VCARD`}
                  size={80}
                  fgColor="#000000"
                />
               
              </div>
            </div>

            {/* <p className="address mt-4 small text-muted">
              <i className="fa fa-map-marker me-2"></i>
              Office No-306, 3rd Floor, RG Trade Tower, <br />
              Netaji Subhash Place, New Delhi - 110034
            </p> */}
          </div>

          {/* Back Side */}
          <div className="card-face card-back p-4">
            <h5 className="brand-title text-center mb-4 d-flex align-items-center">
       <div className="logo-circle d-flex align-items-center justify-content-center me-3 "><img src={logo} width='70' height='auto' alt="" />  </div>      Perfect Tools
            </h5>

            <p className="address small text-muted text-start">
              <div> <i className="fa fa-map-marker me-2"></i>K-63N, Amar Colony, Near Metro Pillar No. 449, Main Roh Nangloi, New Delhi - 110041</div>
            </p>
             <p className="address  small text-muted text-start">
              <div> <i className="fa fa-map-marker me-2"></i> Plot No. 876/2, 38 Mile Stone, NH-48, Village Khandasa, Near Hero Honda Chowk, Gurgaon,

Haryana-122004,</div>
            </p>
             <p className="address  small text-muted text-start">
              <div> <i className="fa fa-map-marker me-2"></i>H-52, Sec-9, Noida (U.P.)</div>
            </p>
            
          </div>
        </div>
      </Tilt>

      {/* Manual flip button */}
      <button
        className="platinum-btn mt-4 rounded-pill"
        onClick={() => setFlipped(!flipped)}
      >
        {flipped ? "Show Front" : "Show Back"}
      </button>

      {/* Action buttons */}
      <div className="d-flex flex-column gap-3 mt-5 w-75 mx-auto" style={{ maxWidth: "280px" }}>
        <a href="/satish.vcf" download className="platinum-btn">Add To Contacts</a>
        <a href="tel:+919310414808" className="platinum-btn">Call Now</a>
        <a href="mailto:satish.perfect@yahoo.com" className="platinum-btn">Email Us</a>
        <a href="https://wa.me/919310414808" target="_blank" className="platinum-btn">
              WhatsApp
          </a>

        <a href="https://perfecttools.in/" target="_blank" rel="noopener noreferrer" className="platinum-btn">Website</a>
        <a href="https://maps.app.goo.gl/N4TzBqa5GTpwejSj9" target="_blank" rel="noopener noreferrer" className="platinum-btn">Address Details</a>
        {/* <a href="/brochure.pdf" download className="platinum-btn">Brochure</a> */}
      </div>
    </div>
  );
};

export default DigitalPlatinumCard;
